import { render, staticRenderFns } from "./filter-brief.vue?vue&type=template&id=a6bca128&"
import script from "./filter-brief.vue?vue&type=script&lang=ts&"
export * from "./filter-brief.vue?vue&type=script&lang=ts&"
import style0 from "./filter-brief.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports